import { ALL_POSTS, POST_RPP, SHOP_RPP, VIDEO_RPP } from '.'

export const INSTAGRAM_ENDPOINT = {
    GET_FEED: (token: string) =>
        `https://graph.instagram.com/me/media?fields=media_count,media_type,permalink,media_url&&access_token=${token}`,
}

export const EDVR_ENDPOINTS = {
    USER_LOGIN: 'api/v2/login',
    USER_SET_PASSWORD: 'api/v2/reset-password',
    USER_RESET_PASSWORD_EMAIL: 'api/v2/reset-password/create',
    REFRESH_TOKEN: 'api/v2/token/refresh',
    USER_UPDATE_PASSWORD: 'api/v2/user/update-password',
    USER_PROFILE: 'api/v2/user/profile',
    USER_LOGOUT: 'api/v2/user/token/delete',
    USER_REGISTRATION: 'api/v2/user',
    USER_ADDRESS: 'api/v2/user/billing-details',
    USER_PREFERENCES: 'api/v2/user/preferences',
    GET_USER_ADDRESS: 'api/v2/user/address',
    GET_GIFT_LICENCE: 'api/v4/gift/products',
    BASKET_CALL: 'api/v2/customer/basket',
    USER_SUBSCRIBED_LICENCE: 'api/v2/user/licence',
    PAY_BASKET: 'api/v2/customer/baskets/pay',
    GIFT_PAY_BASKET: 'api/v4/basket/pay',
    GET_GIFT_BASKET: 'api/v4/basket',
    PAYMENT_INIT: 'api/v4/payment-method/init',
    AVAILABLE_CARDS: 'api/v2/customer/cards',
    GET_LICENCE: 'api/v2/licence',
    GUEST_CHECK_IN: 'api/v2/login/guest/checkin',
    GUEST_USER_DETAIL: 'api/v2/user/guest-checkout-principal',
    PAYMENT_DETAILS: 'api/v2/payment-details',
    REDEEM_PIN: 'api/v2/token/alt/pin/redeem',
    GIFT_VOUCHER_ON_CURRENT_LICENCE: `api/v2/promotions/voucher/redeem`,
    SWITCH_CARD_FOR_ACTIVE_LICENCE: (licenceId: number, cardId: number) =>
        `api/v2/licence/${licenceId}/card/${cardId}`,
    WATCH_HISTORY: (lastSeen: number, rpp: number) =>
        `api/v4/customer/history/vod?&rpp=${rpp}${
            lastSeen !== 0 ? `&lastSeen=${lastSeen}` : ''
        }`,
    DELETE_CARD: (cardId: number) => `api/v2/customer/cards/${cardId}`,
    DEFAULT_CARD: (cardId: number) => `api/v2/customer/cards/${cardId}/default`,
    PAUSE_LICENCE: (licenceId: number) =>
        `api/v4/user/licence/${licenceId}/pause`,
    RESUME_LICENCE: (licenceId: number) =>
        `api/v4/user/licence/${licenceId}/resume`,
    GIFT_VOUCHER: (voucherCode: string) =>
        `api/v2/baskets/vouchers/${voucherCode}`,
    CANCEL_LICENCE: (licenceId: number) => `api/v2/user/licence/${licenceId}`,
    AUTO_RENEW_LICENCE: (licenceId: number) => `api/v2/licence/${licenceId}`,
    UPDATE_USER_ADDRESS: (addressId: string) =>
        `api/v2/user/address/${addressId}`,
    POST_GIFT_LICENCE: (external_id: string) =>
        `api/v4/gift/basket/${external_id}`,
    PUT_BASKET: (basket_key: string) => `api/v2/baskets/${basket_key}`,
    GET_SECTION: (
        name: string,
        items: number,
        lastSeen: number,
        bpp: number = 5
    ) =>
        `api/v4/content/${name}?rpp=${items}&bpp=${bpp}${
            lastSeen !== 0 ? `&lastSeen=${lastSeen}` : ''
        }`, // rpp is number of item
    GET_PLAYLIST: (id: number, lastSeen: number) =>
        `api/v4/playlist/${id}?&rpp=${VIDEO_RPP}${
            lastSeen !== 0 ? `&lastSeen=${lastSeen}` : ''
        }`,
    GET_BUCKET_BY_EXID: (section: string, exid: string, lastSeen: number) =>
        `api/v4/content/${section}/bucket/${exid}?&rpp=${VIDEO_RPP}${
            lastSeen !== 0 ? `&lastSeen=${lastSeen}` : ''
        }`,
    GET_VOD: (id: number) => `api/v4/vod/${id}`,
    GET_VOD_BY_TAGS: (tags: string) =>
        `api/v4/tagged/vod?${tags}&rpp=${VIDEO_RPP}`,
    REDEEM_GIFT_LICENCE: (external_id: string) =>
        `api/v4/gift/redeem/${external_id}`,
    RETRIEVE_GIFT_LICENCE: (external_id: string) =>
        `api/v4/gift/redeem/${external_id}`,
    ADD_DELETE_FAVOURITE: (id: number) => `api/v2/favourite/vods/${id}`,
    GET_FAVOURITES: (p: number) =>
        `api/v2/favourite/vods?rpp=${VIDEO_RPP}&p=${p}`,
    REMOVE_ITEM_FROM_GIFT_BASKET: (external_id: string) =>
        `api/v4/basket/${external_id}`,
    UPCOMING_EVENTS: `api/v4/event/upcoming`,
    LIVE_EVENTS: `api/v4/event/live`,
    GET_EVENT: (id: number) => `api/v4/event/${id}`,
}

export const MW_ENDPOINTS = {
    ONBOARDING_QUESTIONS: 'question',
    ONBOARDING_ANSWER: 'onboarding',
    GET_ONBOARDING_ANSWERS: (id: string) => `onboarding/${id}`,
    USER_PROFILE_IMAGE: (extension: string) => `profile-image/${extension}`,
    USER_PROFILE_IMAGE_S3: (file: string) =>
        `posts/get-upload-url?fileType=${file}`,
    VERIFY_CAPTCHA: 'verify-captcha',
    ACHIEVEMENT_USER: 'user',
    PROGRAM_PROCESS: (playlistId: string) => `playlist/${playlistId}`,
}

export const CS_CDN_ENDPOINTS = {
    SEARCH: (keyword: string, skip: number, rpp: number) =>
        `/post/entries?environment=${process.env.REACT_APP_ENV}&include_count=true&skip=${skip}&limit=${rpp}&query={ 
            "$or": [
                { 
                    "title": { "$regex": "${keyword}", "$options": "i" } 
                }, 
                {
                    "search_meta": { "$regex": "${keyword}", "$options": "i" } 
                },
                { 
                    "content.text.text": { "$regex": "${keyword}", "$options": "i" }
                }

            ]
        }&desc=published_date`,
    GET_POST: (subCategory: string, category: string, skip: number) =>
        `/post/entries?environment=${
            process.env.REACT_APP_ENV
        }&include_count=true&skip=${skip}&limit=${POST_RPP}&query={${
            subCategory !== ALL_POSTS.title
                ? `"sub_category":{"$in_query":{"title":"${subCategory}"}},`
                : ''
        }"category":"${category}" }&desc=published_date`,
    GET_SHOP_CODES: (subCategory: string, category: string, skip: number) =>
        `/shop_mwh_codes/entries?environment=${
            process.env.REACT_APP_ENV
        }&include_count=true&skip=${skip}&limit=${SHOP_RPP}&query={
            "category":{
                "$in_query":{
                    "title": "${category}", "_content_type_uid": "shop_categories"
                }
            }
            ${
                subCategory &&
                ` , "subcategories": {
                "$in_query":{
                    "slug": "${subCategory}", "_content_type_uid": "shop_subcategories"
                }
            }`
            }
         }&desc=published_date`,
}

export const SPLIT_ENDPOINT = {
    SEARCH: () => `v2/my/links/search/`,
}

export const ITERABLE_ENDPOINT = {
    USER_SUBSCRIBED: '/api/lists/subscribe',
    TRACK_EVENT: '/api/events/track',
    UPDATE_USER_DATA: '/api/users/update',
}

export const ZENDESK = {
    REQUEST: `/api/v2/requests.json?async=true`,
}
